module.exports = __webpack_public_path__ + "media/packs/base/stylesheets/fonts/apercu-italic-pro-12a9d32f686c01c2a1098b489f17ab39.eot";